import styled from "styled-components";

export const PostInputWrapper = styled.div`
    max-width: 500px;
`;

export const PostCharacterCount = styled.div`
    text-align: right;
`;
